import React from 'react';

import { css } from '@emotion/react';
import LottiePlayer, { AnimationItem, AnimationSegment } from 'lottie-web';

import CardReveal from 'src/assets/lotties/CardReveal.json';
import { CREDIT_APPLICATION_PAGE_MAX_WIDTH } from 'src/components/creditApplication/constants/dimensions';

type AnimationState = 'in' | 'out';

interface CardRevealPropsIface {
  animationState: AnimationState;
  onComplete: () => void;
}

const AnimationInSegment: AnimationSegment = [0, 70];
const AnimationOutSegment: AnimationSegment = [60, 140];

const CardRevealPage = ({ animationState, onComplete }: CardRevealPropsIface) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const animationRef = React.useRef<AnimationItem | null>(null);

  React.useEffect(() => {
    const segment: AnimationSegment = animationState === 'in' ? AnimationInSegment : AnimationOutSegment;
    if (containerRef.current) {
      animationRef.current = LottiePlayer.loadAnimation({
        container: containerRef.current,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: CardReveal,
      });

      if (animationRef.current) {
        animationRef.current.setSpeed(0.5);
        animationRef.current.playSegments(segment, true);
        animationRef.current.addEventListener('complete', onComplete);
      }
    }

    return () => {
      if (animationRef.current) {
        animationRef.current.removeEventListener('complete', onComplete);
        animationRef.current.destroy();
      }
    };
  }, [animationState, onComplete]);

  return (
    <div css={root}>
      <div ref={containerRef} css={lottie} />
    </div>
  );
};

const root = css`
  height: 100%;
  margin: auto;
  self-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 75px;
  max-width: ${CREDIT_APPLICATION_PAGE_MAX_WIDTH}px;
`;

// NOTE (szhang): This is so the envelope goes wider than the max width of the page
const lottie = css`
  width: 130%;
`;

export default CardRevealPage;
